import { Record as record } from 'immutable';
import { construct, fields } from '../../helpers/LinkMapper';

const defaults = {
    tocCode: null,
    startDate: null,
    endDate: null,
    message: null
};

export default class DisabledService extends record(defaults) {
    static fromJSON (json = {}) {
        return construct(DisabledService, json, {
            tocCode: fields.string,
            startDate: fields.string,
            endDate: fields.string,
            message: fields.string
        });
    }
}
